import React, { Component } from 'react'
import { connect } from 'react-redux'

import Modal from '../../../../components/Modal'
import LoadMask from '../../../../components/LoadMask'
import LuftUserForm from './LuftUserForm'

import { getAddLuftUserUI } from '../../../../redux/selectors'
import { fetchLuftUsers, fetchAddLuftUser, addLuftUserClear } from '../../../../redux/admin-luft-users'

class AddLuftUserModal extends Component {

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(addLuftUserClear());
  }

  _submit = ({ name, email, subsidiaries, roles }) => {
    const { dispatch, onDismiss } = this.props

    dispatch(fetchAddLuftUser(name, email, subsidiaries, roles)).then(
      () => {
        onDismiss()
        dispatch(fetchLuftUsers())
      },
      // reject
      () => { }
    )
  }

  render() {
    const { onDismiss, ui } = this.props

    return (
      <Modal
        title="Novo usuário Luft"
        size="small"
        onBackdropClick={onDismiss}
      >
        <LuftUserForm
          errorMessage={ui.error}
          onDismiss={onDismiss}
          onSubmit={this._submit}
        />
        {
          ui.isFetching &&
          <LoadMask text="Salvando..." />
        }
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: getAddLuftUserUI(state)
  };
}

export default connect(mapStateToProps)(AddLuftUserModal)
